import { FORTEM_URIS } from '@/constants/uris'
import { DataPresencePage } from '@/pages/pm/attributions/data-presence/page'
import { FixedIncomePage } from '@/pages/pm/attributions/fixed-income/page'
import { ModelComparisonPage } from '@/pages/pm/attributions/model-comparison/page'
import { RiskPremiaPage } from '@/pages/pm/attributions/risk-premia/page'
import { PMLayout } from '@/pages/pm/layout'
import { DailyCompositionPage } from '@/pages/pm/premialab/daily-composition/page'
import { UploadTrackPage } from '@/pages/pm/upload-track/page'
import type { CustomRouteObject, FortemRouteHandle } from '@/router'

export const pmRoutes = [
  {
    path: FORTEM_URIS.PM.__INDEX__,
    element: <PMLayout />,
    handle: {
      title: 'PM',
    },
    children: [
      {
        path: FORTEM_URIS.PM.ATTRIBUTIONS.__INDEX__,
        children: [
          {
            path: FORTEM_URIS.PM.ATTRIBUTIONS.DATA_PRESENCE,
            element: <DataPresencePage />,
          },
          {
            path: FORTEM_URIS.PM.ATTRIBUTIONS.RISK_PREMIA,
            element: <RiskPremiaPage />,
          },
          {
            path: FORTEM_URIS.PM.ATTRIBUTIONS.FIXED_INCOME,
            element: <FixedIncomePage />,
          },
          {
            path: FORTEM_URIS.PM.ATTRIBUTIONS.FUND_ATTRIBUTIONS,
            element: <ModelComparisonPage />,
          },
        ],
      },
      {
        path: FORTEM_URIS.PM.PREMIALAB.__INDEX__,
        children: [
          {
            path: FORTEM_URIS.PM.PREMIALAB.DAILY_COMPOSITION,
            element: <DailyCompositionPage />,
          },
        ],
      },
      {
        path: FORTEM_URIS.PM.UPLOAD_TRACK,
        element: <UploadTrackPage />,
      },
    ],
  },
] satisfies CustomRouteObject<FortemRouteHandle>[]
